<template>
<div>
    <v-container fluid grid-list-md px-0>
        <v-layout row wrap>
             <v-flex xs11>
              <v-snackbar
                    v-model="alert" 
                    color="green lighten-2" 
                    class="white--text" 
                    top outlined dense 
                    type="success" text>
                    {{ message }}
                    <v-btn color="white" text  @click="alert = false">  <v-icon color="maroon">mdi-close</v-icon></v-btn>
                </v-snackbar>
                 <v-snackbar
                    v-model="alert_error" 
                    color="red lighten-2" 
                    class="white--text" 
                    top outlined dense
                    type="error" text>
                    {{ error }}
                    <v-btn color="white"  text  @click="alert_error = false"> Close</v-btn>
                </v-snackbar>
           </v-flex>
            <v-flex xs12>
                    <div>
                        <v-layout row wrap fill-height class="pa-2 header">
                            <v-flex xs12 sm2 md2>
                                <div class="title text-color">Users</div>
                            </v-flex>
                            <v-flex xs12 sm10 md10 class="filter_form">
                            <v-form
                             @submit.prevent="validateBeforeSubmit('filterList')" 
                             data-vv-scope="filterList"
                              id="filterList" 
                              ref="form">
                                <v-layout row wrap>
                                    <v-flex xs12 sm6 md3>
                                        <v-text-field name="Name" 
                                        label="Search By Username" 
                                        id="name" 
                                        regular
                                        single-line 
                                        v-model="filters.name">
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm6 md2>
                                        <v-text-field name="Role" 
                                        label="Role" 
                                        id="role" 
                                        regular
                                        single-line 
                                        v-model="filters.role">
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex xs6 sm12 md3 class='buttoncenter pl-5'>
                                        <v-btn small color="primary" type="submit">Apply</v-btn>
                                        <v-btn small color="primary" class="btn_reset ml-1" @click="resetFilter">Reset</v-btn>
                                    </v-flex>
                                    <v-flex xs6 sm12 md4>
                                        <v-btn color="primary" class="float_right ml-3" @click="upload_user_dialog_box=true" small>Upload Users</v-btn>
                                        <v-btn color="primary" class="float_right" to="/addUser" small>Create user</v-btn>
                                    </v-flex>
                                </v-layout>
                            </v-form>
                        </v-flex>
                           
                        </v-layout>
                        <v-layout row wrap class="mt-2">
                            <v-flex sm12 md12>
                                <v-data-table :headers="headers" :items="users"
                                :footer-props="{'items-per-page-options': [15,20,40,80]}" 
                                item-key="id" class="elevation-1" :loading="is_loading" :options.sync="options" :server-items-length="total_items" :items-per-page="15">
                                    <template v-slot:body="{ items }"  v-if="!is_loading && total_items!='0'">
                                        <tbody>
                                            <tr v-for="item in items" :key="item.id ">
                                                <td>
                                                    <router-link :to="{ name:'showUserDetails',params: { id:item.id } }">{{ item.username}}</router-link>
                                                </td>

                                               
                                                <td v-if="item.office">
                                                    <router-link :to="{ name:'showOfficeDetails',params: { id:item.office.id } }">{{ item.office.name }}</router-link>
                                                </td>
                                                <td v-else> - </td>
                                                <td v-if="item.roles[0]">{{item.roles[0].display_name}}</td>
                                                <td v-else>-</td>
                                                <td>
                                                    <v-btn text icon color="primary" :to="`users/edit/${item.id}`">
                                                        <v-icon>edit</v-icon>
                                                    </v-btn>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </template>
                                   <template v-slot:loading> Loading... Please wait </template>
                        <template v-slot:no-results> No data available </template>
                                </v-data-table>
                            </v-flex>

                        </v-layout>
                    </div>
               
            </v-flex>
        </v-layout>

        <!-- filter model -->
        <v-dialog v-model="filter_dialog_box" persistent :overlay="false" max-width="500px" transition="dialog-transition">
            <v-card>
                <v-form @submit.prevent='validateBeforeSubmit("filterList")' data-vv-scope="filterList" id="filterList" ref="form">
                    <v-card-text>
                        <v-card-title primary-title>
                            <span class="headline">Filters</span>
                        </v-card-title>
                        <v-container fluid grid-list-md>
                            <v-layout row wrap>
                                <v-flex xs12 md6>
                                    <v-text-field name="Name" label="Name" id="name" v-model="filters.name"></v-text-field>
                                </v-flex>
                                <!-- <v-flex xs12 md6>
                        <v-text-field
                          name="Employee ID"
                          label="Employee ID"
                          id="employee_id"
                          v-model="filters.employee_id"
                        ></v-text-field>
                      </v-flex> -->
                            </v-layout>
                            <!-- <v-layout row wrap>
                      <v-flex xs12 md6>
                        <v-text-field
                          name="Mobile"
                          label="Mobile"
                          id="mobile"
                          v-model="filters.mobile"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 md6>
                        <v-autocomplete
                            :items="office_list"
                            name="Office"
                            v-model="filters.office_id"
                            label="Office"
                            item-text="name"
                            return-object
                            item-value="id"
                            clearable
                            >
                          </v-autocomplete>
                      </v-flex>
                    </v-layout> -->
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn small color="primary" type="submit">Apply</v-btn>
                        <v-btn text small color="error" @click="resetFilter">Reset</v-btn>
                        <v-btn text small @click=" filter_dialog_box =  false">Cancel</v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>

        <!-- Delete User model -->
        <v-dialog v-model="delete_user_dialog_box" scrollable :overlay="false" max-width="600px" transition="dialog-transition">
            <v-card>
                <v-form>
                    <v-card-text>
                        <v-card-title primary-title>
                            <span class="headline">Are you sure you want to delete this User ?</span>
                        </v-card-title>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" small @click="confirmDeleteUser">Delete</v-btn>
                        <v-btn color="black" text small @click="delete_user_dialog_box=false">Cancel</v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>

        <!-- Upload User model -->
    <v-dialog v-model="upload_user_dialog_box" 
    scrollable 
    :overlay="false" 
    max-width="600px"
    min-height="800px" 
    transition="dialog-transition">
        <v-card class='pa-5'>
            <v-form>
                  <v-card-title>
                    <p class="text-color pb-0">Upload file</p>
                </v-card-title>
                <v-card-text>
                    <v-file-input
                            v-model="files"
                            label="File input"
                            placeholder="Select your files"
                            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" 
                            :show-size="1000"
                        ></v-file-input>
                </v-card-text>
                <!-- <v-card-text>
                    <p>Sample Formate :</p>
                    <v-img :src='images'></v-img>
                </v-card-text> -->
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" small @click="uploadfile">Upload</v-btn>
                    <v-btn color="black" text small @click="upload_user_dialog_box=false">Cancel</v-btn>
                </v-card-actions>      
            </v-form>
        </v-card>
    </v-dialog>
    </v-container>
</div>
</template>

<script>
export default {
    watch: {
        options: {
            handler() {
                this.getList();
            }
        },

    },
    methods: {
        getList: function () {
            this.is_loading = true;
            this.options.filters = Object.assign({}, this.filters);
            axios.get(`${process.env.VUE_APP_API_URL}/api/users`, {
                params: this.options
            }).then((response) => {
                if (response.data.status == 1) {
                    this.users = response.data.users_list.data;
                    this.total_items = response.data.users_list.total;
                    this.is_loading = false;

                }
                if (response.data.status == 0) {
                    this.error = "Error Occured";
                }
            }).catch((error) => {
                console.log(error);

            }).finally(() => {
                {

                }
            });
        },
        getofficeList() {
            this.is_loading = true;
            axios.get(`${process.env.VUE_APP_API_URL}/api/offices`).then((response) => {
                if (response.data.status == 1) {
                    this.office_list = response.data.office_list.data;
                    this.is_loading = false;

                }
                if (response.data.status == 0) {
                    this.error = "Error Occured";
                }
            }).catch((error) => {
                console.log(error);

            }).finally(() => {
                {

                }
            });
        },
        validateBeforeSubmit: function (scope) {
            this.$validator.validateAll(scope).then(result => {
                if (result) {
                    this[scope]();
                }
            });
        },
        filterList() {
            let filter_values = Object.values(this.filters);
            if (filter_values.join('').length > 0) {
                this.$router.replace({
                    name: "users",
                    query: {
                        filters: true,
                        name: this.filters.name,
                        role: this.filters.role,
                    }
                });
                this.displayFilterChips(this.filters);
                this.is_filtered = true;
            } else {
                this.$router.replace({
                    name: "users"
                });
            }
            this.getList();
            this.filter_dialog_box = false;
        },
        clearFilter: function (filter, key) {
            this.filter_chips[key] = this.filters[key] = '';
            this.filterList();
        },
        resetFilter() {
            this.resetFiltersParameters();
            this.$router.replace({
                name: 'users',
                query: {}
            });
            this.getList();
            this.resetFiltersParameters();
            this.is_filtered = false;
            this.filter_dialog_box = false;
        },
        resetFiltersParameters: function () {
            for (var key in this.filters) {
                this.filters[key] = '';
                this.filter_chips[key] = '';
            }
        },
        applyFiltersOnLoad: function () {
            this.filters.name = this.$route.query.name;
            this.filters.role = this.$route.query.role;
            this.displayFilterChips(this.filters);
        },
        displayFilterChips: function (filters) {
            if (this.$route.query.filters) {
                this.filter_chips.name = filters.name;
                this.filter_chips.role = filters.role;
                this.is_filtered = true;
            }
        },
        deleteUser: function (user) {
            this.delete_user_dialog_box = true;
            this.to_be_deleted_user = user;
        },
        confirmDeleteUser: function () {

            axios
                .post(`${process.env.VUE_APP_API_URL}/api/users/` + this.to_be_deleted_user.id + `/delete`).then((response) => {
                    if (response.data.status == 1) {
                        this.response_message = response.data.message;
                        this.delete_user_dialog_box = false;
                        this.getList();
                    }
                    if (response.data.status == 0) {
                        this.error = "Error Occured";
                    }

                }).catch((error) => {
                    console.log(error);

                }).finally(() => {
                    {

                    }
                });
        },
        uploadfile: function () {
            let formData = new FormData();
            formData.append('file', this.files);
            axios.post(`${process.env.VUE_APP_API_URL}/api/users/uploadusers`,
                    formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                )
                .then((response) => {
                    this.upload_user_dialog_box = false;
                    if (response.data.status == 1) {
                        this.alert=true;
                        this.message = response.data.message;
                        window.location.reload();
                    }
                    if (response.data.status == 0) {
                        this.alert_error=true;
                        this.error = response.data.message;
                    }
                })
                .catch(function () {

                });

        },

    },
    data() {
        return {
            options: {},
            error: '',
            headers: [{
                    text: 'User Name',
                    align: 'left',
                    value: 'username',
                    sortable:false
                },
                {
                    text: 'Office',
                    value: 'office.name',
                    sortable:false
                },
                {
                    text: 'Role',
                    value: 'role',
                    sortable:false
                },
                 {
                    text: 'Edit',
                    value: 'edit',
                    sortable:false
                },
                
            ],
            users: [],
            filters: {
                name: '',
                role:'',
            },
            filter_chips: {
                name: '',
                role: ''
            },
            filter_dialog_box: false,
            office_list: [],
            is_filtered: false,
            is_loading: false,
            total_items: 10,
            delete_user_dialog_box: false,
            to_be_deleted_user: {},
            upload_user_dialog_box:false,
            files:null,
            message:'',
            alert: false,
            alert_error:false
        }
    },
    mounted() {
         if(this.$route.params.success_message!=null) 
        {    this.alert=true;
            this.message = this.$route.params.success_message;
        }
        this.applyFiltersOnLoad();
        this.getofficeList()
    },
};
</script>
